import { render, staticRenderFns } from "./ELayoutPublico.vue?vue&type=template&id=85468d60&scoped=true"
import script from "./ELayoutPublico.vue?vue&type=script&lang=js"
export * from "./ELayoutPublico.vue?vue&type=script&lang=js"
import style0 from "./ELayoutPublico.vue?vue&type=style&index=0&id=85468d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85468d60",
  null
  
)

export default component.exports